import CollapsibleList from 'lib/CollapsibleList';
import CollapsibleListStatsHeader from 'lib/CollapsibleList/CollapsibleListStatsHeader';
import { FormatLabel, FormatOption } from 'store/userOptions/reducer.types';
import SelectOption from 'lib/SelectOption';
import { shouldDisplayCategoryClearAll } from 'components/pages/Planner/PlannerSections/FiltersContent/utils';
import { FormatOptionsProps } from 'components/common/FormatOptions/FormatOptions.types';
import React from 'react';

export const FormatOptions: React.FC<FormatOptionsProps> = ({
  filteredOptions,
  selectedFormats,
  onCategoryDirectionSort,
  sortDirection,
  onToggleCategory,
  setSelectedOptions,
  getNumberOfFilteredOptions,
  isOptionIncluded,
  isOptionSelected,
  onOptionIncludeExcludeChange,
  openCategories,
  includedOptions,
  excludedOptions,
  hideExclude,
  onCategoryIncludeAll,
  onCategoryExcludeAll,
  getCategoryIncludeState,
}) => {
  return (
    <>
      {Object.keys(filteredOptions).map((category: FormatOption) => {
        const selectedOptions = selectedFormats.filter(
          (dealLineFormat) => dealLineFormat.category !== FormatLabel[category],
        );

        return (
          <CollapsibleList
            label={FormatLabel[category]}
            isSortVisible
            onSort={onCategoryDirectionSort}
            sortDir={sortDirection}
            isOpen={openCategories.includes(category)}
            category={category}
            onToggle={onToggleCategory}
            isClearAllVisible={shouldDisplayCategoryClearAll(selectedFormats, FormatLabel[category])}
            onClearAll={() => setSelectedOptions(selectedOptions)}
            key={`format-category-${FormatLabel[category]}`}
            groupIncludeState={getCategoryIncludeState(category)}
            onGroupInclude={onCategoryIncludeAll}
            onGroupExclude={onCategoryExcludeAll}
            hideGroupExclude={hideExclude}
            headerComponent={
              <CollapsibleListStatsHeader
                available={filteredOptions?.[category].length}
                included={getNumberOfFilteredOptions(category, includedOptions)}
                excluded={getNumberOfFilteredOptions(category, excludedOptions)}
              />
            }
          >
            {filteredOptions?.[category].map(({ code, name }) => {
              return (
                <SelectOption
                  value={{
                    code,
                    name,
                    include: isOptionSelected(code, category) ? isOptionIncluded(code, category) : undefined,
                  }}
                  key={`select-category-${code}`}
                  isSelected={isOptionSelected(code, category)}
                  isDisabled={false}
                  isMultiple
                  hasCheckbox={false}
                  hideExclude={hideExclude}
                  isIncludeExcludeAlwaysVisible
                  onIncludeExcludeChange={(value) =>
                    onOptionIncludeExcludeChange({
                      ...value,
                      category: FormatLabel[category],
                    })
                  }
                  classNames="!m-0"
                >
                  {name}
                </SelectOption>
              );
            })}
          </CollapsibleList>
        );
      })}
    </>
  );
};
